module.exports = __webpack_public_path__ + "static/media/dwg.b5ca247c.svg";